import React from 'react';
import PropTypes from 'prop-types';
import StarRating from '@homeaway/react-star-rating';

function HitRating({
    averageRating,
    reviewCount
}) {
    let rating = null;

    if (averageRating && reviewCount > 0) {
        rating = (
            <div className="ratings-wrapper">
                <StarRating rating={averageRating}/>
                <span className="review-count">{reviewCount}</span>
            </div>
        );
    }

    return (
        <div className="hit-ratings hidden-mini">
            {rating}
        </div>
    );
}

HitRating.propTypes = {
    averageRatingClass: PropTypes.string,
    reviewCount: PropTypes.number
};

export default HitRating;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitRating/HitRating.js